export default __webpack_public_path__ + "static/media/goapackage.8a6d6bdc.jpeg";